<template>
  <div class="alarm-center">
    <!-- 左侧面板 - 暂时隐藏 -->
    <div v-if="false" class="alarm-left-panel-wrapper">
      <div class="alarm-left-panel">
        <!-- 左侧面板内容为空 -->
      </div>
    </div>

    <!-- 中央地图 -->
    <div class="alarm-center-panel">
      <div id="health-amap-container" class="amap-container">
        <!-- 摄像头监控模块已移除 -->
      </div>
    </div>

    <!-- 右侧面板 -->
    <div class="alarm-right-panel-wrapper">
      <div class="alarm-right-panel">
        <!-- 手表 -->
        <div class="card section-watch">
          <div class="section-header">
            <div class="section-title">手表</div>
            <button class="btn btn-sm" @click="showWatchDetail">详情</button>
          </div>
          <MetricCards
            :metrics="watchMetrics"
            :format-value="formatWatchValue"
            :get-color="getWatchColor"
          />
        </div>

        <!-- 胸卡 -->
        <div class="card section-badge">
          <div class="section-header">
            <div class="section-title">胸卡</div>
            <button class="btn btn-sm" @click="showBadgeDetail">详情</button>
          </div>
          <MetricCards
            :metrics="badgeMetrics"
            :format-value="formatBadgeValue"
            :get-color="getBadgeColor"
          />
        </div>

        <!-- 定位器 -->
        <div class="card section-locator">
          <div class="section-header">
            <div class="section-title">定位器</div>
            <button class="btn btn-sm" @click="showLocatorDetail">详情</button>
          </div>
          <MetricCards
            :metrics="locatorMetrics"
            :format-value="formatLocatorValue"
            :get-color="getLocatorColor"
          />
        </div>
      </div>
    </div>

    <!-- 手表详情弹窗 -->
    <div v-if="showWatchDetailDialog" class="environment-detail-mask" @click="closeWatchDetail">
      <div ref="watchDetailContainerRef" class="environment-detail-modal" @click.stop>
        <div class="environment-detail-header">
          <div class="environment-detail-title">手表详情</div>
          <div class="environment-detail-actions">
            <button class="icon-btn" type="button" title="关闭" @click="closeWatchDetail">×</button>
          </div>
        </div>
        <div class="environment-detail-body">
          <DetailStats
            v-if="showWatchDetailDialog"
            :title="watchDetailTitle"
            :basic-stats="watchBasicStats"
            :chart-groups="watchChartGroups"
            :trend-data="watchTrendData"
            :format-value="formatWatchValue"
            :get-color="getWatchColor"
          />
        </div>
      </div>
    </div>

    <!-- 胸卡详情弹窗 -->
    <div v-if="showBadgeDetailDialog" class="environment-detail-mask" @click="closeBadgeDetail">
      <div ref="badgeDetailContainerRef" class="environment-detail-modal" @click.stop>
        <div class="environment-detail-header">
          <div class="environment-detail-title">胸卡详情</div>
          <div class="environment-detail-actions">
            <button class="icon-btn" type="button" title="关闭" @click="closeBadgeDetail">×</button>
          </div>
        </div>
        <div class="environment-detail-body">
          <DetailStats
            v-if="showBadgeDetailDialog"
            :title="badgeDetailTitle"
            :basic-stats="badgeBasicStats"
            :chart-groups="badgeChartGroups"
            :trend-data="badgeTrendData"
            :format-value="formatBadgeValue"
            :get-color="getBadgeColor"
          />
        </div>
      </div>
    </div>

    <!-- 定位器详情弹窗 -->
    <div v-if="showLocatorDetailDialog" class="environment-detail-mask" @click="closeLocatorDetail">
      <div ref="locatorDetailContainerRef" class="environment-detail-modal" @click.stop>
        <div class="environment-detail-header">
          <div class="environment-detail-title">定位器详情</div>
          <div class="environment-detail-actions">
            <button class="icon-btn" type="button" title="关闭" @click="closeLocatorDetail">×</button>
          </div>
        </div>
        <div class="environment-detail-body">
          <DetailStats
            v-if="showLocatorDetailDialog"
            :title="locatorDetailTitle"
            :basic-stats="locatorBasicStats"
            :chart-groups="locatorChartGroups"
            :trend-data="locatorTrendData"
            :format-value="formatLocatorValue"
            :get-color="getLocatorColor"
          />
        </div>
      </div>
    </div>

    <!-- 视频播放器弹窗 -->
    <div v-if="videoPlayerVisible" class="video-mask" @click="closeVideoPlayer">
      <div ref="videoContainerRef" class="video-modal" @click.stop>
        <div class="video-header">
          <div class="video-title">{{ videoPlayerTitle }}</div>
          <div class="video-actions">
            <button class="icon-btn" type="button" title="全屏" @click="toggleVideoFullscreen">⛶</button>
            <button class="icon-btn" type="button" title="关闭" @click="closeVideoPlayer">×</button>
          </div>
        </div>
        <div class="video-body">
          <div v-if="videoPlayerUrl" ref="videoPlayerContainer" class="jessibuca-container-modal"></div>
          <div v-else class="video-empty">暂无视频流</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { communityStore } from '../stores/community'
import { getCommunityConfig } from '../utils/communityConfig'
import { REFRESH_CONFIG } from '../utils/refreshConfig'
import DetailStats from './DetailStats.vue'
import MetricCards from './MetricCards.vue'
import request from '@/utils/request'
import { getCurrentCommunity } from '@/utils/vc'

export default {
  name: 'HealthLife',
  components: {
    DetailStats,
    MetricCards
  },
  data() {
    return {
      communityStore,
      // 高德地图
      map: null,
      boundaryPolyline: null,
      // 宠物活动轨迹
      petTracks: [],
      petTrackPolylines: [],
      petCurrentMarkers: [],
      // 摄像头列表显示/隐藏
      listVisible: true,
      // 摄像头列表
      cameraList: [
        {
          id: 'CAM-001',
          name: '主入口监控',
          image: '',
          url: 'ws://example.com/stream1' // 模拟视频流地址
        },
        {
          id: 'CAM-002',
          name: '1栋南侧监控',
          image: '',
          url: 'ws://example.com/stream2'
        },
        {
          id: 'CAM-003',
          name: '2栋北侧监控',
          image: '',
          url: 'ws://example.com/stream3'
        },
        {
          id: 'CAM-004',
          name: '3栋东侧监控',
          image: '',
          url: 'ws://example.com/stream4'
        },
        {
          id: 'CAM-005',
          name: '4栋西侧监控',
          image: '',
          url: 'ws://example.com/stream5'
        },
        {
          id: 'CAM-006',
          name: '5栋中心监控',
          image: '',
          url: 'ws://example.com/stream6'
        },
        {
          id: 'CAM-007',
          name: '停车场监控',
          image: '',
          url: 'ws://example.com/stream7'
        },
        {
          id: 'CAM-008',
          name: '社区广场监控',
          image: '',
          url: 'ws://example.com/stream8'
        }
      ],
      // 视频播放器弹窗
      videoPlayerVisible: false,
      videoPlayerUrl: '',
      videoPlayerTitle: '摄像头监控',
      modalJessibuca: null, // 弹窗中的播放器实例
      // 定时器
      watchTimer: null, // 手表数据刷新定时器
      badgeTimer: null, // 胸卡数据刷新定时器
      locatorTimer: null, // 定位器数据刷新定时器
      // 手表数据
      watchMetrics: [],
      watchTrendData: null,
      showWatchDetailDialog: false, // 控制手表详情弹窗显示
      // 手表详情配置
      watchDetailTitle: '手表',
      watchChartGroups: [
        {
          title: '步数与心率',
          fields: ['steps', 'heartRate']
        },
        {
          title: '血压',
          fields: ['highPressure', 'lowPressure']
        },
        {
          title: '血氧',
          fields: ['bloodOxygen']
        },
        {
          title: '电量',
          fields: ['batteryLevel']
        }
      ],
      // 胸卡数据
      badgeMetrics: [],
      badgeTrendData: null,
      showBadgeDetailDialog: false, // 控制胸卡详情弹窗显示
      // 胸卡详情配置
      badgeDetailTitle: '胸卡',
      badgeChartGroups: [
        {
          title: '电量',
          fields: ['batteryLevel']
        },
        {
          title: '步数',
          fields: ['steps']
        }
      ],
      // 定位器数据
      locatorMetrics: [],
      locatorTrendData: null,
      showLocatorDetailDialog: false, // 控制定位器详情弹窗显示
      // 定位器详情配置
      locatorDetailTitle: '定位器',
      locatorChartGroups: [
        {
          title: '电量',
          fields: ['batteryLevel']
        },
        {
          title: '步数',
          fields: ['steps']
        }
      ]
    }
  },
  computed: {
    // 将 watchMetrics 转换为 basicStats 格式，并添加颜色类型
    watchBasicStats() {
      if (!this.watchMetrics || !Array.isArray(this.watchMetrics)) {
        return []
      }
      return this.watchMetrics.map(metric => ({
        ...metric,
        colorType: this.getWatchColorType(metric.label, metric.value)
      }))
    },
    // 将 badgeMetrics 转换为 basicStats 格式，并添加颜色类型
    badgeBasicStats() {
      if (!this.badgeMetrics || !Array.isArray(this.badgeMetrics)) {
        return []
      }
      return this.badgeMetrics.map(metric => ({
        ...metric,
        colorType: this.getBadgeColorType(metric.label, metric.value)
      }))
    },
    // 将 locatorMetrics 转换为 basicStats 格式，并添加颜色类型
    locatorBasicStats() {
      if (!this.locatorMetrics || !Array.isArray(this.locatorMetrics)) {
        return []
      }
      return this.locatorMetrics.map(metric => ({
        ...metric,
        colorType: this.getLocatorColorType(metric.label, metric.value)
      }))
    }
  },
  watch: {
    'communityStore.currentCommunity'() {
      this.loadCommunityData()
      this.loadWatchData() // 社区切换时重新加载手表数据
      this.loadBadgeData() // 社区切换时重新加载胸卡数据
      this.loadLocatorData() // 社区切换时重新加载定位器数据
    },
  },
  mounted() {
    // 加载手表数据
    this.loadWatchData()
    // 加载胸卡数据
    this.loadBadgeData()
    // 加载定位器数据
    this.loadLocatorData()

    // 初始化高德地图
    this.$nextTick(() => {
      setTimeout(() => {
        this.initAmap()
      }, 200)
    })

    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize)

    // 定时刷新手表数据
    this.watchTimer = setInterval(() => {
      this.loadWatchData()
    }, REFRESH_CONFIG.ENVIRONMENT_MONITOR) // 使用环境监测的刷新间隔（5秒）

    // 定时刷新胸卡数据
    this.badgeTimer = setInterval(() => {
      this.loadBadgeData()
    }, REFRESH_CONFIG.ENVIRONMENT_MONITOR) // 使用环境监测的刷新间隔（5秒）

    // 定时刷新定位器数据
    this.locatorTimer = setInterval(() => {
      this.loadLocatorData()
    }, REFRESH_CONFIG.ENVIRONMENT_MONITOR) // 使用环境监测的刷新间隔（5秒）
  },
  beforeDestroy() {
    // 清理定时器
    if (this.watchTimer) {
      clearInterval(this.watchTimer)
      this.watchTimer = null
    }
    if (this.badgeTimer) {
      clearInterval(this.badgeTimer)
      this.badgeTimer = null
    }
    if (this.locatorTimer) {
      clearInterval(this.locatorTimer)
      this.locatorTimer = null
    }

    // 移除事件监听
    window.removeEventListener('resize', this.handleResize)

    // 销毁视频播放器
    if (this.modalJessibuca) {
      try {
        this.modalJessibuca.destroy()
      } catch (err) {
        console.warn('销毁弹窗播放器失败:', err)
      }
      this.modalJessibuca = null
    }

      // 销毁高德地图
      if (this.map) {
        // 清除宠物轨迹
        this.clearPetTracks()
        
        if (this.boundaryPolyline) {
          this.map.remove(this.boundaryPolyline)
          this.boundaryPolyline = null
        }
        this.map.destroy()
        this.map = null
      }
  },
  methods: {
    handleResize() {
      if (this.map) {
        this.map.resize()
      }
    },
    initAmap() {
      if (typeof window.AMap === 'undefined') {
        console.error('高德地图 API 未加载')
        return
      }
      
      const container = document.getElementById('health-amap-container')
      if (!container) {
        console.error('地图容器不存在')
        return
      }
      
      // 初始化高德地图 - 使用深色科技主题
      this.map = new window.AMap.Map('health-amap-container', {
        zoom: 17, // 初始缩放级别
        center: [114.0, 33.0], // 默认中心点，后续会根据配置更新
        mapStyle: 'amap://styles/darkblue', // 使用高德内置深蓝色主题，科技感强
        viewMode: '2D',
        features: ['bg', 'point', 'road', 'building']
      })
      
      // 地图加载完成后加载数据
      this.map.on('complete', () => {
        this.loadCommunityData()
      })
    },
    loadCommunityData() {
      if (!this.map) return
      const cfg = getCommunityConfig(this.communityStore.currentCommunity)

      // 清除现有边界
      if (this.boundaryPolyline) {
        this.map.remove(this.boundaryPolyline)
        this.boundaryPolyline = null
      }

      // 清除现有宠物轨迹
      this.clearPetTracks()

      // 加载边界
      if (cfg && cfg.boundary && cfg.boundary.length > 0) {
        const path = cfg.boundary.map((p) => [p.longitude, p.latitude])
        this.boundaryPolyline = new window.AMap.Polyline({
          path: path,
          strokeColor: '#00d4ff',
          strokeWeight: 3,
          strokeOpacity: 0.8,
          zIndex: 1
        })
        this.map.add(this.boundaryPolyline)
      }

      // 加载宠物活动轨迹
      this.loadPetTracks(cfg)

      // 设置视角
      if (cfg && cfg.view) {
        this.flyToCommunity(cfg.view)
      }
    },
    // 清除宠物轨迹
    clearPetTracks() {
      // 清除轨迹线
      this.petTrackPolylines.forEach(polyline => {
        if (polyline) {
          this.map.remove(polyline)
        }
      })
      this.petTrackPolylines = []
      
      // 清除当前位置标记
      this.petCurrentMarkers.forEach(marker => {
        if (marker) {
          this.map.remove(marker)
        }
      })
      this.petCurrentMarkers = []
    },
    // 加载宠物活动轨迹（全新设计，更真实美观）
    loadPetTracks(cfg) {
      if (!this.map) return
      
      const centerLon = cfg && cfg.view && cfg.view.longitude ? cfg.view.longitude : 114.0
      const centerLat = cfg && cfg.view && cfg.view.latitude ? cfg.view.latitude : 33.0
      
      // 生成更真实的宠物轨迹数据（使用平滑曲线算法）
      const pets = [
        {
          id: 'pet-001',
          name: '小花',
          color: '#FF6B9D',
          gradientColors: ['#FF6B9D', '#FF8EAF', '#FFB5D1'],
          // 生成自然的轨迹路径（模拟真实宠物活动）
          startPos: [centerLon - 0.003, centerLat - 0.002],
          endPos: [centerLon + 0.0025, centerLat + 0.002]
        },
        {
          id: 'pet-002',
          name: '小黑',
          color: '#4ECDC4',
          gradientColors: ['#4ECDC4', '#6EDDD6', '#8EEDE8'],
          startPos: [centerLon + 0.002, centerLat - 0.0025],
          endPos: [centerLon - 0.002, centerLat + 0.0025]
        },
        {
          id: 'pet-003',
          name: '小白',
          color: '#FFE66D',
          gradientColors: ['#FFE66D', '#FFED8D', '#FFF4AD'],
          startPos: [centerLon - 0.0025, centerLat + 0.002],
          endPos: [centerLon + 0.003, centerLat - 0.0015]
        }
      ]
      
      pets.forEach((pet, index) => {
        // 生成平滑的轨迹路径（使用贝塞尔曲线）
        const smoothTrack = this.generateSmoothPetTrack(pet.startPos, pet.endPos)
        
        // 绘制平滑轨迹线（使用分段渐变）
        this.drawSmoothTrackLine(smoothTrack, pet, index)
        
        // 绘制起点标记（更美观的设计）
        this.drawStartMarker(pet.startPos, pet, index)
        
        // 绘制终点标记（当前位置，带动画效果）
        this.drawCurrentMarker(pet.endPos, pet, index)
      })
    },
    // 生成平滑的宠物轨迹路径（使用贝塞尔曲线）
    generateSmoothPetTrack(startPos, endPos) {
      // 计算中间控制点，生成自然的曲线路径
      const dx = endPos[0] - startPos[0]
      const dy = endPos[1] - startPos[1]
      const distance = Math.sqrt(dx * dx + dy * dy)
      
      // 生成2-3个中间控制点，模拟宠物活动的随机性
      const controlPoints = []
      const numControls = 2 + Math.floor(Math.random() * 2) // 2-3个控制点
      
      for (let i = 0; i < numControls; i++) {
        const t = (i + 1) / (numControls + 1)
        // 在起点和终点之间添加随机偏移，模拟真实活动路径
        const randomOffsetX = (Math.random() - 0.5) * distance * 0.3
        const randomOffsetY = (Math.random() - 0.5) * distance * 0.3
        
        controlPoints.push([
          startPos[0] + dx * t + randomOffsetX,
          startPos[1] + dy * t + randomOffsetY
        ])
      }
      
      // 使用Catmull-Rom样条生成平滑路径点
      const allPoints = [startPos, ...controlPoints, endPos]
      const smoothPath = []
      
      // 添加起点
      smoothPath.push(startPos)
      
      // 在每两个点之间生成平滑曲线
      for (let i = 0; i < allPoints.length - 1; i++) {
        const p0 = i === 0 ? allPoints[0] : allPoints[i - 1]
        const p1 = allPoints[i]
        const p2 = allPoints[i + 1]
        const p3 = i === allPoints.length - 2 ? allPoints[allPoints.length - 1] : allPoints[i + 2]
        
        // 生成10个中间点，形成平滑曲线
        for (let j = 1; j < 10; j++) {
          const t = j / 10
          const point = this.catmullRomSpline(p0, p1, p2, p3, t)
          smoothPath.push(point)
        }
      }
      
      // 添加终点
      smoothPath.push(endPos)
      
      return smoothPath
    },
    // Catmull-Rom样条曲线算法
    catmullRomSpline(p0, p1, p2, p3, t) {
      const t2 = t * t
      const t3 = t2 * t
      
      const x = 0.5 * (
        (2 * p1[0]) +
        (-p0[0] + p2[0]) * t +
        (2 * p0[0] - 5 * p1[0] + 4 * p2[0] - p3[0]) * t2 +
        (-p0[0] + 3 * p1[0] - 3 * p2[0] + p3[0]) * t3
      )
      
      const y = 0.5 * (
        (2 * p1[1]) +
        (-p0[1] + p2[1]) * t +
        (2 * p0[1] - 5 * p1[1] + 4 * p2[1] - p3[1]) * t2 +
        (-p0[1] + 3 * p1[1] - 3 * p2[1] + p3[1]) * t3
      )
      
      return [x, y]
    },
    // 绘制平滑轨迹线（带渐变效果）
    drawSmoothTrackLine(track, pet, index) {
      const segmentLength = 8 // 每段轨迹的长度（点数）
      
      for (let i = 0; i < track.length - 1; i += segmentLength) {
        const segmentEnd = Math.min(i + segmentLength, track.length)
        const segment = track.slice(i, segmentEnd)
        
        if (segment.length < 2) continue
        
        // 计算该段的进度（0-1）
        const progress = i / (track.length - 1)
        
        // 根据进度计算颜色（从起点到终点渐变）
        let trackColor = pet.gradientColors[0]
        if (progress < 0.33) {
          const t = progress / 0.33
          trackColor = this.interpolateColor(pet.gradientColors[0], pet.gradientColors[1], t)
        } else if (progress < 0.66) {
          const t = (progress - 0.33) / 0.33
          trackColor = this.interpolateColor(pet.gradientColors[1], pet.gradientColors[2], t)
        } else {
          const t = (progress - 0.66) / 0.34
          trackColor = this.interpolateColor(pet.gradientColors[2], pet.color, t)
        }
        
        // 创建轨迹线段
        const polyline = new window.AMap.Polyline({
          path: segment,
          strokeColor: trackColor,
          strokeWeight: 4,
          strokeOpacity: 0.6,
          lineJoin: 'round',
          lineCap: 'round',
          zIndex: 5 + index
        })
        
        this.map.add(polyline)
        this.petTrackPolylines.push(polyline)
      }
      
      // 添加轨迹点标记（每隔一定距离显示一个小点）
      for (let i = 5; i < track.length - 5; i += 15) {
        const point = track[i]
        const progress = i / (track.length - 1)
        
        const pointColor = progress < 0.5
          ? this.interpolateColor(pet.gradientColors[0], pet.gradientColors[1], progress * 2)
          : this.interpolateColor(pet.gradientColors[1], pet.gradientColors[2], (progress - 0.5) * 2)
        
        const pointMarker = new window.AMap.Marker({
          position: point,
          content: `<div style="
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background: ${pointColor};
            border: 2px solid rgba(255, 255, 255, 0.8);
            box-shadow: 0 0 6px ${pointColor}, 0 0 12px ${pointColor}40;
            animation: petTrackPulse 2s ease-in-out infinite;
          "></div>`,
          anchor: 'center',
          zIndex: 7 + index
        })
        
        this.map.add(pointMarker)
        this.petCurrentMarkers.push(pointMarker)
      }
    },
    // 绘制起点标记
    drawStartMarker(position, pet, index) {
      const startIcon = this.createStartEndIcon(pet.color, 'start')
      const startMarker = new window.AMap.Marker({
        position: position,
        icon: startIcon,
        anchor: 'bottom-center',
        zIndex: 12 + index,
        extData: {
          type: 'start',
          petId: pet.id,
          petName: pet.name
        }
      })
      
      this.map.add(startMarker)
      this.petCurrentMarkers.push(startMarker)
    },
    // 绘制当前位置标记（带动画效果）
    drawCurrentMarker(position, pet, index) {
      const petIcon = this.getPetIcon(pet.color, pet.gradientColors)
      const currentMarkerContent = `
        <div class="pet-marker-wrapper marker-pet-${pet.id}" style="
          position: relative;
          animation: petMarkerFloat 3s ease-in-out infinite;
        ">
          <div class="pet-marker-label" style="
            background: linear-gradient(135deg, ${pet.color}dd, ${pet.color}aa);
            border: 2px solid ${pet.color};
            color: #fff;
            padding: 4px 10px;
            border-radius: 12px;
            font-size: 12px;
            font-weight: bold;
            white-space: nowrap;
            box-shadow: 0 2px 8px ${pet.color}60, 0 0 12px ${pet.color}40;
            margin-bottom: 8px;
          ">${pet.name}</div>
          <div class="marker-pulse" style="
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 60px;
            height: 60px;
            border-radius: 50%;
            background: ${pet.color}20;
            animation: petPulse 2s ease-out infinite;
          "></div>
          <img src="${petIcon}" class="pet-marker-icon" style="
            width: 40px;
            height: 40px;
            position: relative;
            z-index: 2;
            filter: drop-shadow(0 2px 4px rgba(0,0,0,0.3));
          " />
        </div>
      `
      
      const currentMarker = new window.AMap.Marker({
        position: position,
        content: currentMarkerContent,
        anchor: 'bottom-center',
        zIndex: 15 + index,
        extData: {
          petId: pet.id,
          petName: pet.name,
          type: 'current'
        }
      })
      
      currentMarker.on('click', () => {
        console.log('点击宠物:', pet.name)
      })
      
      this.map.add(currentMarker)
      this.petCurrentMarkers.push(currentMarker)
    },
    // 创建起点/终点图标（更美观的设计）
    createStartEndIcon(color, type) {
      const canvas = document.createElement('canvas')
      const size = 28
      canvas.width = size
      canvas.height = size
      const ctx = canvas.getContext('2d')
      
      ctx.clearRect(0, 0, size, size)
      
      // 绘制外圈光晕
      const gradient = ctx.createRadialGradient(size / 2, size / 2, 0, size / 2, size / 2, size / 2)
      gradient.addColorStop(0, color + '80')
      gradient.addColorStop(1, color + '00')
      ctx.fillStyle = gradient
      ctx.beginPath()
      ctx.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2)
      ctx.fill()
      
      // 绘制主圆
      ctx.beginPath()
      ctx.arc(size / 2, size / 2, size / 2 - 3, 0, Math.PI * 2)
      ctx.fillStyle = color
      ctx.fill()
      ctx.strokeStyle = '#fff'
      ctx.lineWidth = 2.5
      ctx.stroke()
      
      // 绘制图标文字
      ctx.fillStyle = '#fff'
      ctx.font = 'bold 14px Arial'
      ctx.textAlign = 'center'
      ctx.textBaseline = 'middle'
      ctx.fillText(type === 'start' ? 'S' : 'E', size / 2, size / 2)
      
      return new window.AMap.Icon({
        size: new window.AMap.Size(size, size),
        image: canvas.toDataURL('image/png'),
        imageSize: new window.AMap.Size(size, size)
      })
    },
    // 获取定位图标（起点/终点）
    getLocationIcon(color, type) {
      const canvas = document.createElement('canvas')
      const size = 24
      canvas.width = size
      canvas.height = size
      const ctx = canvas.getContext('2d')
      
      ctx.clearRect(0, 0, size, size)
      
      // 绘制外圈
      ctx.beginPath()
      ctx.arc(size / 2, size / 2, size / 2 - 2, 0, Math.PI * 2)
      ctx.fillStyle = color
      ctx.fill()
      ctx.strokeStyle = '#fff'
      ctx.lineWidth = 2
      ctx.stroke()
      
      // 绘制定位图标（起点显示S，终点显示E）
      ctx.fillStyle = '#fff'
      ctx.font = 'bold 12px Arial'
      ctx.textAlign = 'center'
      ctx.textBaseline = 'middle'
      ctx.fillText(type === 'start' ? 'S' : 'E', size / 2, size / 2)
      
      return new window.AMap.Icon({
        size: new window.AMap.Size(size, size),
        image: canvas.toDataURL('image/png'),
        imageSize: new window.AMap.Size(size, size)
      })
    },
    // 获取宠物图标
    getPetIcon(color, gradientColors) {
      const canvas = document.createElement('canvas')
      const size = 32
      canvas.width = size
      canvas.height = size
      const ctx = canvas.getContext('2d')
      
      ctx.clearRect(0, 0, size, size)
      
      const centerX = size / 2
      const centerY = size / 2
      
      // 绘制外圈
      ctx.beginPath()
      ctx.arc(centerX, centerY, size / 2 - 2, 0, Math.PI * 2)
      // 渐变填充
      const gradient = ctx.createRadialGradient(centerX, centerY, 0, centerX, centerY, size / 2)
      gradient.addColorStop(0, gradientColors[0])
      gradient.addColorStop(1, gradientColors[1])
      ctx.fillStyle = gradient
      ctx.fill()
      ctx.strokeStyle = '#fff'
      ctx.lineWidth = 2
      ctx.stroke()
      
      // 绘制宠物图标（🐾）
      ctx.font = '20px Arial'
      ctx.textAlign = 'center'
      ctx.textBaseline = 'middle'
      ctx.fillText('🐾', centerX, centerY)
      
      return canvas.toDataURL('image/png')
    },
    // 颜色插值
    interpolateColor(color1, color2, factor) {
      const hex1 = color1.replace('#', '')
      const hex2 = color2.replace('#', '')
      const r1 = parseInt(hex1.substr(0, 2), 16)
      const g1 = parseInt(hex1.substr(2, 2), 16)
      const b1 = parseInt(hex1.substr(4, 2), 16)
      const r2 = parseInt(hex2.substr(0, 2), 16)
      const g2 = parseInt(hex2.substr(2, 2), 16)
      const b2 = parseInt(hex2.substr(4, 2), 16)
      const r = Math.round(r1 + (r2 - r1) * factor)
      const g = Math.round(g1 + (g2 - g1) * factor)
      const b = Math.round(b1 + (b2 - b1) * factor)
      return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`
    },
    flyToCommunity(view) {
      if (!this.map || !view) return
      
      // 优先使用边界范围
      if (this.boundaryPolyline) {
        const bounds = this.boundaryPolyline.getBounds()
        if (bounds) {
          // 设置合适的边距，确保能看到完整的边界线
          this.map.setBounds(bounds, false, [60, 60, 60, 60])
          // 限制缩放级别，稍微放大一点
          setTimeout(() => {
            const currentZoom = this.map.getZoom()
            // 如果缩放级别太大（>17），缩小到17
            if (currentZoom > 17) {
              this.map.setZoom(17)
            } else if (currentZoom < 15) {
              // 如果缩放级别太小，适当放大到15
              this.map.setZoom(15)
            }
          }, 100)
          return
        }
      }
      
      // 如果没有边界，使用配置的中心点和缩放级别
      let zoom = 17 // 默认缩放级别
      if (view.height) {
        // height 越大，缩放级别越小（地图越远）
        if (view.height > 2000) zoom = 16
        else if (view.height > 1000) zoom = 17
        else if (view.height > 500) zoom = 17
        else zoom = 17
      }
      
      this.map.setCenter([view.longitude || 114.0, view.latitude || 33.0])
      this.map.setZoom(zoom)
    },
    showDetails() {
      // TODO: 弹窗显示详情
    },
    viewCameraDetail(camera) {
      // 点击摄像头放大查看
      this.videoPlayerTitle = camera.name || '摄像头监控'
      this.videoPlayerUrl = camera.url || ''
      this.videoPlayerVisible = true

      // 在弹窗中初始化播放器
      this.$nextTick(() => {
        if (this.videoPlayerUrl && this.$refs.videoPlayerContainer) {
          this.initVideoPlayerModal(this.videoPlayerUrl)
        }
      })
    },
    /**
     * 在弹窗中初始化视频播放器
     */
    initVideoPlayerModal(videoUrl) {
      // 检查 Jessibuca 是否可用
      if (typeof window.Jessibuca === 'undefined') {
        console.error('Jessibuca 未加载')
        return
      }

      // 销毁旧的播放器（如果存在）
      if (this.modalJessibuca) {
        try {
          this.modalJessibuca.destroy()
        } catch (err) {
          console.warn('销毁弹窗播放器失败:', err)
        }
        this.modalJessibuca = null
      }

      const container = this.$refs.videoPlayerContainer
      if (!container) {
        return
      }

      try {
        // 创建播放器实例
        this.modalJessibuca = new window.Jessibuca({
          container: container,
          videoBuffer: 0.2,
          isResize: false,
          text: '',
          loadingText: '',
          useMSE: false,
          debug: false,
          isNotMute: false,
          supportDblclickFullscreen: false, // 禁用双击全屏
          operateBtns: {
            fullscreen: false, // 禁用全屏按钮
            screenshot: false, // 禁用截图按钮
            play: false, // 禁用播放/暂停按钮
            audio: false, // 禁用音频按钮
            recorder: false // 禁用录制按钮
          }
        })

        // 播放视频
        this.modalJessibuca.play(videoUrl)

        // 监听事件
        this.modalJessibuca.on('start', () => {
          console.log('弹窗视频开始播放')
        })

        this.modalJessibuca.on('error', (error) => {
          console.error('弹窗视频播放错误:', error)
        })

      } catch (error) {
        console.error('初始化弹窗播放器失败:', error)
      }
    },
    closeVideoPlayer() {
      // 销毁弹窗中的播放器
      if (this.modalJessibuca) {
        try {
          this.modalJessibuca.destroy()
        } catch (err) {
          console.warn('销毁弹窗播放器失败:', err)
        }
        this.modalJessibuca = null
      }

      this.videoPlayerVisible = false
      this.videoPlayerUrl = ''
    },
    toggleVideoFullscreen() {
      const el = this.$refs.videoContainerRef
      if (!el) return
      if (!document.fullscreenElement) {
        el.requestFullscreen().catch(() => {})
      } else {
        document.exitFullscreen().catch(() => {})
      }
    },
    // 显示手表详情
    showWatchDetail() {
      this.showWatchDetailDialog = true
    },
    // 关闭手表详情
    closeWatchDetail() {
      this.showWatchDetailDialog = false
    },
    // 加载手表数据
    loadWatchData() {
      // 只在首次加载或数据为空时设置默认数据
      if (!this.watchMetrics || this.watchMetrics.length === 0) {
        const cfg = getCommunityConfig(this.communityStore.currentCommunity)
        if (cfg.data && cfg.data.watch) {
          // 深拷贝配置数据，避免直接修改全局配置
          this.watchMetrics = JSON.parse(JSON.stringify(cfg.data.watch.metrics || []))
          this.watchTrendData = cfg.data.watch.trend ? JSON.parse(JSON.stringify(cfg.data.watch.trend)) : null
        } else {
          this.watchMetrics = []
          this.watchTrendData = null
        }
      }

      // 获取当前社区的 communityId
      let communityId = null
      try {
        const currentCommunity = getCurrentCommunity()
        if (currentCommunity && currentCommunity.communityId) {
          communityId = currentCommunity.communityId
        }
      } catch (e) {
        console.warn('获取 communityId 失败:', e)
        // 即使获取 communityId 失败，也保持现有数据不变
        return
      }

      if (!communityId) {
        console.warn('communityId 为空，无法调用接口，保持现有数据')
        return
      }

      console.log('开始调用手表监测接口，communityId:', communityId)
      // 调用接口获取手表监测数据
      request({
        url: '/app/bigScreen/getWatch',
        method: 'get',
        params: {
          communityId: communityId,
          deviceCode: '9519980739' // 手表设备编号
        },
        showLoading: false
      }).then(response => {
        console.log('手表监测接口返回:', response)
        const res = response.data
        console.log('手表监测接口响应数据:', res)
        if (res && res.code === 0 && res.data) {
          const data = res.data
          console.log('手表监测接口返回的数据:', data)

          // 基于当前组件数据更新，而不是重新从配置读取
          const metrics = this.watchMetrics && this.watchMetrics.length > 0
            ? JSON.parse(JSON.stringify(this.watchMetrics))
            : (() => {
                const cfg = getCommunityConfig(this.communityStore.currentCommunity)
                return cfg.data && cfg.data.watch ? JSON.parse(JSON.stringify(cfg.data.watch.metrics || [])) : []
              })()

          // 从后端返回的数据中根据 field 匹配并更新 value
          if (data.watch && data.watch.metrics) {
            const backendMetrics = data.watch.metrics
            metrics.forEach(configMetric => {
              if (configMetric.field) {
                const backendMetric = backendMetrics.find(bm => bm.field === configMetric.field)
                if (backendMetric && backendMetric.value !== undefined && backendMetric.value !== null && backendMetric.value !== '') {
                  configMetric.value = String(backendMetric.value || '0')
                }
                // 如果接口没有返回该字段的数据，保持当前值不变（不重置为0）
              }
            })
          }

          // 更新趋势数据
          let trend = this.watchTrendData ? JSON.parse(JSON.stringify(this.watchTrendData)) : null
          if (!trend) {
            const cfg = getCommunityConfig(this.communityStore.currentCommunity)
            trend = cfg.data && cfg.data.watch && cfg.data.watch.trend
              ? JSON.parse(JSON.stringify(cfg.data.watch.trend))
              : null
          }

          if (data.watch && data.watch.trend && trend) {
            const backendTrend = data.watch.trend
            if (backendTrend.series && trend.series) {
              backendTrend.series.forEach(backendSeries => {
                const configSeries = trend.series.find(cs => cs.field === backendSeries.field)
                if (configSeries) {
                  configSeries.data = backendSeries.data || []
                } else {
                  const metric = metrics.find(m => m.field === backendSeries.field)
                  if (metric) {
                    trend.series.push({
                      name: metric.label,
                      unit: metric.unit,
                      field: backendSeries.field,
                      data: backendSeries.data || [],
                      min: metric.min || 0,
                      max: metric.max || 100
                    })
                  }
                }
              })
            }
          }

          // 更新组件数据（直接使用接口返回的数据，不强制更新最后一个值）
          this.watchMetrics = metrics
          this.watchTrendData = trend
          console.log('手表监测数据已更新:', this.watchMetrics)
        } else {
          console.warn('手表监测接口返回数据格式不正确:', res)
          // 即使接口返回格式不正确，也保持使用已设置的默认配置数据
        }
      }).catch(error => {
        console.error('获取手表监测数据失败:', error)
        // 接口失败时保持使用已设置的默认配置数据，不重新设置
      })
    },
    // 格式化手表指标显示值
    formatWatchValue(label, value) {
      // 对于非数值类型（如定位时间），直接返回原值
      if (label.includes('定位时间') || label.includes('纬度') || label.includes('经度')) {
        return value
      }

      // 数值类型指标，保留适当小数位
      const numValue = parseFloat(value)
      if (isNaN(numValue)) {
        return value
      }

      // 根据指标类型决定小数位数
      if (label.includes('电量') || label.includes('血氧')) {
        return Math.round(numValue).toString()
      } else if (label.includes('步数') || label.includes('心率')) {
        return Math.round(numValue).toString()
      } else if (label.includes('血压') || label.includes('低压') || label.includes('高压')) {
        return Math.round(numValue).toString()
      }
      return numValue.toString()
    },
    // 获取手表指标颜色类型
    getWatchColorType(label, value) {
      // 对于非数值类型（如定位时间、纬度、经度），返回蓝色
      if (label.includes('定位时间') || label.includes('纬度') || label.includes('经度')) {
        return 'blue'
      }

      const numValue = parseFloat(value) || 0

      if (label.includes('电量')) {
        // 电量：80-100%绿色(充足)，50-80%蓝色(正常)，20-50%黄色(偏低)，<20%红色(低)
        if (numValue >= 80) {
          return 'green'
        } else if (numValue >= 50) {
          return 'blue'
        } else if (numValue >= 20) {
          return 'yellow'
        } else {
          return 'red'
        }
      } else if (label.includes('步数')) {
        // 步数：>10000步绿色(优秀)，5000-10000步蓝色(良好)，3000-5000步黄色(一般)，<3000步红色(不足)
        if (numValue >= 10000) {
          return 'green'
        } else if (numValue >= 5000) {
          return 'blue'
        } else if (numValue >= 3000) {
          return 'yellow'
        } else {
          return 'red'
        }
      } else if (label.includes('血氧')) {
        // 血氧：95-100%绿色(正常)，90-95%蓝色(偏低)，85-90%黄色(异常)，<85%红色(危险)
        if (numValue >= 95) {
          return 'green'
        } else if (numValue >= 90) {
          return 'blue'
        } else if (numValue >= 85) {
          return 'yellow'
        } else {
          return 'red'
        }
      } else if (label.includes('低压')) {
        // 低压：60-80mmHg绿色(正常)，50-60或80-90mmHg蓝色(较正常)，40-50或90-100mmHg黄色(异常)，其他红色(极端)
        if (numValue >= 60 && numValue <= 80) {
          return 'green'
        } else if ((numValue >= 50 && numValue < 60) || (numValue > 80 && numValue <= 90)) {
          return 'blue'
        } else if ((numValue >= 40 && numValue < 50) || (numValue > 90 && numValue <= 100)) {
          return 'yellow'
        } else {
          return 'red'
        }
      } else if (label.includes('高压')) {
        // 高压：90-120mmHg绿色(正常)，80-90或120-140mmHg蓝色(较正常)，70-80或140-160mmHg黄色(异常)，其他红色(极端)
        if (numValue >= 90 && numValue <= 120) {
          return 'green'
        } else if ((numValue >= 80 && numValue < 90) || (numValue > 120 && numValue <= 140)) {
          return 'blue'
        } else if ((numValue >= 70 && numValue < 80) || (numValue > 140 && numValue <= 160)) {
          return 'yellow'
        } else {
          return 'red'
        }
      } else if (label.includes('心率')) {
        // 心率：60-100bpm绿色(正常)，50-60或100-120bpm蓝色(较正常)，40-50或120-150bpm黄色(异常)，其他红色(极端)
        if (numValue >= 60 && numValue <= 100) {
          return 'green'
        } else if ((numValue >= 50 && numValue < 60) || (numValue > 100 && numValue <= 120)) {
          return 'blue'
        } else if ((numValue >= 40 && numValue < 50) || (numValue > 120 && numValue <= 150)) {
          return 'yellow'
        } else {
          return 'red'
        }
      }
      // 默认蓝色
      return 'blue'
    },
    // 获取手表指标值的颜色（返回CSS颜色值）
    getWatchColor(label, value) {
      const colorType = this.getWatchColorType(label, value)
      const colorMap = {
        'green': '#4caf50',
        'blue': '#00d4ff',
        'yellow': '#ffc107',
        'red': '#ff5a5a'
      }
      return colorMap[colorType] || '#00d4ff'
    },
    // 显示胸卡详情
    showBadgeDetail() {
      this.showBadgeDetailDialog = true
    },
    // 关闭胸卡详情
    closeBadgeDetail() {
      this.showBadgeDetailDialog = false
    },
    // 加载胸卡数据
    loadBadgeData() {
      // 只在首次加载或数据为空时设置默认数据
      if (!this.badgeMetrics || this.badgeMetrics.length === 0) {
        const cfg = getCommunityConfig(this.communityStore.currentCommunity)
        if (cfg.data && cfg.data.badge) {
          // 深拷贝配置数据，避免直接修改全局配置
          this.badgeMetrics = JSON.parse(JSON.stringify(cfg.data.badge.metrics || []))
          this.badgeTrendData = cfg.data.badge.trend ? JSON.parse(JSON.stringify(cfg.data.badge.trend)) : null
        } else {
          this.badgeMetrics = []
          this.badgeTrendData = null
        }
      }

      // 获取当前社区的 communityId
      let communityId = null
      try {
        const currentCommunity = getCurrentCommunity()
        if (currentCommunity && currentCommunity.communityId) {
          communityId = currentCommunity.communityId
        }
      } catch (e) {
        console.warn('获取 communityId 失败:', e)
        // 即使获取 communityId 失败，也保持现有数据不变
        return
      }

      if (!communityId) {
        console.warn('communityId 为空，无法调用接口，保持现有数据')
        return
      }

      console.log('开始调用胸卡监测接口，communityId:', communityId)
      // 调用接口获取胸卡监测数据
      request({
        url: '/app/bigScreen/getBadge',
        method: 'get',
        params: {
          communityId: communityId,
          deviceCode: '1703621678' // 胸卡设备编号
        },
        showLoading: false
      }).then(response => {
        console.log('胸卡监测接口返回:', response)
        const res = response.data
        console.log('胸卡监测接口响应数据:', res)
        if (res && res.code === 0 && res.data) {
          const data = res.data
          console.log('胸卡监测接口返回的数据:', data)

          // 基于当前组件数据更新，而不是重新从配置读取
          const metrics = this.badgeMetrics && this.badgeMetrics.length > 0
            ? JSON.parse(JSON.stringify(this.badgeMetrics))
            : (() => {
                const cfg = getCommunityConfig(this.communityStore.currentCommunity)
                return cfg.data && cfg.data.badge ? JSON.parse(JSON.stringify(cfg.data.badge.metrics || [])) : []
              })()

          // 从后端返回的数据中根据 field 匹配并更新 value
          if (data.badge && data.badge.metrics) {
            const backendMetrics = data.badge.metrics
            metrics.forEach(configMetric => {
              if (configMetric.field) {
                const backendMetric = backendMetrics.find(bm => bm.field === configMetric.field)
                if (backendMetric && backendMetric.value !== undefined && backendMetric.value !== null && backendMetric.value !== '') {
                  configMetric.value = String(backendMetric.value || '0')
                }
                // 如果接口没有返回该字段的数据，保持当前值不变（不重置为0）
              }
            })
          }

          // 更新趋势数据
          let trend = this.badgeTrendData ? JSON.parse(JSON.stringify(this.badgeTrendData)) : null
          if (!trend) {
            const cfg = getCommunityConfig(this.communityStore.currentCommunity)
            trend = cfg.data && cfg.data.badge && cfg.data.badge.trend
              ? JSON.parse(JSON.stringify(cfg.data.badge.trend))
              : null
          }

          if (data.badge && data.badge.trend && trend) {
            const backendTrend = data.badge.trend
            if (backendTrend.series && trend.series) {
              backendTrend.series.forEach(backendSeries => {
                const configSeries = trend.series.find(cs => cs.field === backendSeries.field)
                if (configSeries) {
                  configSeries.data = backendSeries.data || []
                } else {
                  const metric = metrics.find(m => m.field === backendSeries.field)
                  if (metric) {
                    trend.series.push({
                      name: metric.label,
                      unit: metric.unit,
                      field: backendSeries.field,
                      data: backendSeries.data || [],
                      min: metric.min || 0,
                      max: metric.max || 100
                    })
                  }
                }
              })
            }
          }

          // 更新组件数据（直接使用接口返回的数据，不强制更新最后一个值）
          this.badgeMetrics = metrics
          this.badgeTrendData = trend
          console.log('胸卡监测数据已更新:', this.badgeMetrics)
        } else {
          console.warn('胸卡监测接口返回数据格式不正确:', res)
        }
      }).catch(error => {
        console.error('获取胸卡监测数据失败:', error)
        // 接口失败时保持使用默认配置数据
      })
    },
    // 格式化胸卡指标显示值
    formatBadgeValue(label, value) {
      // 对于非数值类型（如定位时间、纬度、经度），直接返回原值
      if (label.includes('定位时间') || label.includes('纬度') || label.includes('经度')) {
        return value
      }

      // 数值类型指标，保留适当小数位
      const numValue = parseFloat(value)
      if (isNaN(numValue)) {
        return value
      }

      // 根据指标类型决定小数位数
      if (label.includes('电量')) {
        return Math.round(numValue).toString()
      } else if (label.includes('步数')) {
        return Math.round(numValue).toString()
      }
      return numValue.toString()
    },
    // 获取胸卡指标颜色类型
    getBadgeColorType(label, value) {
      // 对于非数值类型（如定位时间、纬度、经度），返回蓝色
      if (label.includes('定位时间') || label.includes('纬度') || label.includes('经度')) {
        return 'blue'
      }

      const numValue = parseFloat(value) || 0

      if (label.includes('电量')) {
        // 电量：80-100%绿色(充足)，50-80%蓝色(正常)，20-50%黄色(偏低)，<20%红色(低)
        if (numValue >= 80) {
          return 'green'
        } else if (numValue >= 50) {
          return 'blue'
        } else if (numValue >= 20) {
          return 'yellow'
        } else {
          return 'red'
        }
      } else if (label.includes('步数')) {
        // 步数：>10000步绿色(优秀)，5000-10000步蓝色(良好)，3000-5000步黄色(一般)，<3000步红色(不足)
        if (numValue >= 10000) {
          return 'green'
        } else if (numValue >= 5000) {
          return 'blue'
        } else if (numValue >= 3000) {
          return 'yellow'
        } else {
          return 'red'
        }
      }
      // 默认蓝色
      return 'blue'
    },
    // 获取胸卡指标值的颜色（返回CSS颜色值）
    getBadgeColor(label, value) {
      const colorType = this.getBadgeColorType(label, value)
      const colorMap = {
        'green': '#4caf50',
        'blue': '#00d4ff',
        'yellow': '#ffc107',
        'red': '#ff5a5a'
      }
      return colorMap[colorType] || '#00d4ff'
    },
    // 显示定位器详情
    showLocatorDetail() {
      this.showLocatorDetailDialog = true
    },
    // 关闭定位器详情
    closeLocatorDetail() {
      this.showLocatorDetailDialog = false
    },
    // 加载定位器数据
    loadLocatorData() {
      // 只在首次加载或数据为空时设置默认数据
      if (!this.locatorMetrics || this.locatorMetrics.length === 0) {
        const cfg = getCommunityConfig(this.communityStore.currentCommunity)
        if (cfg.data && cfg.data.locator) {
          // 深拷贝配置数据，避免直接修改全局配置
          this.locatorMetrics = JSON.parse(JSON.stringify(cfg.data.locator.metrics || []))
          this.locatorTrendData = cfg.data.locator.trend ? JSON.parse(JSON.stringify(cfg.data.locator.trend)) : null
        } else {
          this.locatorMetrics = []
          this.locatorTrendData = null
        }
      }

      // 获取当前社区的 communityId
      let communityId = null
      try {
        const currentCommunity = getCurrentCommunity()
        if (currentCommunity && currentCommunity.communityId) {
          communityId = currentCommunity.communityId
        }
      } catch (e) {
        console.warn('获取 communityId 失败:', e)
        // 即使获取 communityId 失败，也保持现有数据不变
        return
      }

      if (!communityId) {
        console.warn('communityId 为空，无法调用接口，保持现有数据')
        return
      }

      console.log('开始调用定位器监测接口，communityId:', communityId)
      // 调用接口获取定位器监测数据
      request({
        url: '/app/bigScreen/getLocator',
        method: 'get',
        params: {
          communityId: communityId,
          deviceCode: '16079999460' // 定位器设备编号
        },
        showLoading: false
      }).then(response => {
        console.log('定位器监测接口返回:', response)
        const res = response.data
        console.log('定位器监测接口响应数据:', res)
        if (res && res.code === 0 && res.data) {
          const data = res.data
          console.log('定位器监测接口返回的数据:', data)

          // 基于当前组件数据更新，而不是重新从配置读取
          const metrics = this.locatorMetrics && this.locatorMetrics.length > 0
            ? JSON.parse(JSON.stringify(this.locatorMetrics))
            : (() => {
                const cfg = getCommunityConfig(this.communityStore.currentCommunity)
                return cfg.data && cfg.data.locator ? JSON.parse(JSON.stringify(cfg.data.locator.metrics || [])) : []
              })()

          // 从后端返回的数据中根据 field 匹配并更新 value
          if (data.locator && data.locator.metrics) {
            const backendMetrics = data.locator.metrics
            metrics.forEach(configMetric => {
              if (configMetric.field) {
                const backendMetric = backendMetrics.find(bm => bm.field === configMetric.field)
                if (backendMetric && backendMetric.value !== undefined && backendMetric.value !== null && backendMetric.value !== '') {
                  configMetric.value = String(backendMetric.value || '0')
                }
                // 如果接口没有返回该字段的数据，保持当前值不变（不重置为0）
              }
            })
          }

          // 更新趋势数据
          let trend = this.locatorTrendData ? JSON.parse(JSON.stringify(this.locatorTrendData)) : null
          if (!trend) {
            const cfg = getCommunityConfig(this.communityStore.currentCommunity)
            trend = cfg.data && cfg.data.locator && cfg.data.locator.trend
              ? JSON.parse(JSON.stringify(cfg.data.locator.trend))
              : null
          }

          if (data.locator && data.locator.trend && trend) {
            const backendTrend = data.locator.trend
            if (backendTrend.series && trend.series) {
              backendTrend.series.forEach(backendSeries => {
                const configSeries = trend.series.find(cs => cs.field === backendSeries.field)
                if (configSeries) {
                  configSeries.data = backendSeries.data || []
                } else {
                  const metric = metrics.find(m => m.field === backendSeries.field)
                  if (metric) {
                    trend.series.push({
                      name: metric.label,
                      unit: metric.unit,
                      field: backendSeries.field,
                      data: backendSeries.data || [],
                      min: metric.min || 0,
                      max: metric.max || 100
                    })
                  }
                }
              })
            }
          }

          // 更新组件数据（直接使用接口返回的数据，不强制更新最后一个值）
          this.locatorMetrics = metrics
          this.locatorTrendData = trend
          console.log('定位器监测数据已更新:', this.locatorMetrics)
        } else {
          console.warn('定位器监测接口返回数据格式不正确:', res)
          // 即使接口返回格式不正确，也保持使用已设置的默认配置数据
        }
      }).catch(error => {
        console.error('获取定位器监测数据失败:', error)
        // 接口失败时保持使用已设置的默认配置数据，不重新设置
      })
    },
    // 格式化定位器指标显示值
    formatLocatorValue(label, value) {
      // 对于非数值类型（如定位时间、纬度、经度），直接返回原值
      if (label.includes('定位时间') || label.includes('纬度') || label.includes('经度')) {
        return value
      }

      // 数值类型指标，保留适当小数位
      const numValue = parseFloat(value)
      if (isNaN(numValue)) {
        return value
      }

      // 根据指标类型决定小数位数
      if (label.includes('电量')) {
        return Math.round(numValue).toString()
      } else if (label.includes('步数')) {
        return Math.round(numValue).toString()
      }
      return numValue.toString()
    },
    // 获取定位器指标颜色类型
    getLocatorColorType(label, value) {
      // 对于非数值类型（如定位时间、纬度、经度），返回蓝色
      if (label.includes('定位时间') || label.includes('纬度') || label.includes('经度')) {
        return 'blue'
      }

      const numValue = parseFloat(value) || 0

      if (label.includes('电量')) {
        // 电量：80-100%绿色(充足)，50-80%蓝色(正常)，20-50%黄色(偏低)，<20%红色(低)
        if (numValue >= 80) {
          return 'green'
        } else if (numValue >= 50) {
          return 'blue'
        } else if (numValue >= 20) {
          return 'yellow'
        } else {
          return 'red'
        }
      } else if (label.includes('步数')) {
        // 步数：>10000步绿色(优秀)，5000-10000步蓝色(良好)，3000-5000步黄色(一般)，<3000步红色(不足)
        if (numValue >= 10000) {
          return 'green'
        } else if (numValue >= 5000) {
          return 'blue'
        } else if (numValue >= 3000) {
          return 'yellow'
        } else {
          return 'red'
        }
      }
      // 默认蓝色
      return 'blue'
    },
    // 获取定位器指标值的颜色（返回CSS颜色值）
    getLocatorColor(label, value) {
      const colorType = this.getLocatorColorType(label, value)
      const colorMap = {
        'green': '#4caf50',
        'blue': '#00d4ff',
        'yellow': '#ffc107',
        'red': '#ff5a5a'
      }
      return colorMap[colorType] || '#00d4ff'
    }
  }
}
</script>

<style lang="scss" scoped>
.alarm-center {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

// ========== 地图容器（底部背景层）==========
.alarm-center-panel {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 1; // 地图在底部
}

// ========== 左侧面板（覆盖在地图上，响应式）==========
.alarm-left-panel-wrapper {
  position: absolute;
  top: 20px;
  left: 20px;
  width: min(400px, 20vw); // 自适应：最大400px，或屏幕宽度的20%
  min-width: 300px; // 最小宽度
  max-width: 400px; // 最大宽度
  height: calc(100% - 40px);
  z-index: 10; // 左侧面板在地图上方
  border-radius: 8px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: rgba(15, 30, 50, 0.85);
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
  
  // 响应式调整
  @media (max-width: 1920px) {
    width: min(380px, 20vw);
    max-width: 380px;
  }
  
  @media (max-width: 1600px) {
    width: min(350px, 22vw);
    max-width: 350px;
    min-width: 280px;
  }
  
  @media (max-width: 1366px) {
    width: min(320px, 24vw);
    max-width: 320px;
    min-width: 260px;
  }
}

.alarm-left-panel {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1; // 占据剩余空间
  min-height: 0; // 重要：允许 flex 子元素缩小
  overflow-y: auto; // 内容超出时显示滚动条
  overflow-x: hidden;
  max-height: 100%; // 限制最大高度，确保可以滚动

  // 隐藏滚动条但保留滚动功能
  scrollbar-width: none; // Firefox
  -ms-overflow-style: none; // IE/Edge

  &::-webkit-scrollbar {
    display: none; // Chrome/Safari
  }

  ::v-deep .card {
    padding: 10px; // 与社区态势保持一致
  }

  ::v-deep .section-title {
    margin-bottom: 0; // 与社区态势保持一致
    font-size: 14px; // 与社区态势保持一致
  }

  // 所有卡片默认根据内容自适应
  .card {
    flex: 0 0 auto;
    min-height: 0; // 允许收缩
  }

  // 最后一个卡片占据剩余空间，并设置为 flex 容器
  .card:last-child {
    flex: 1 0 auto; // 占据剩余空间，但不收缩，允许根据内容增长
    display: flex;
    flex-direction: column;
    // 不设置 min-height，让内容自然增长
    // 不设置 overflow，让内容自然溢出，由父容器 .alarm-left-panel 处理滚动
  }
}


.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.trend-controls,
.ranking-controls {
  display: flex;
  gap: 8px;
  margin-bottom: 10px;
  justify-content: flex-end;
}

.time-btn {
  padding: 4px 12px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(30, 40, 60, 0.8);
  color: #a0b3c8;
  border-radius: 12px;
  cursor: pointer;
  font-size: 11px;
  transition: all 0.2s;
  white-space: nowrap;
  &:hover {
    border-color: rgba(255, 255, 255, 0.3);
    background: rgba(40, 50, 70, 0.9);
  }
  &.active {
    background: #7A8BEF;
    border-color: #7A8BEF;
    color: #fff;
    font-weight: 500;
  }
}

.trend-chart,
.ranking-chart {
  flex: 1;
  min-height: 170px; // 设置最小高度，确保图表能显示
  .chart-container {
    width: 100%;
    height: 100%;
    min-height: 170px; // 确保容器有最小高度
  }
}

.workorder-content {
  display: flex;
  gap: 16px;
  flex: 1;
  min-height: 0;
}

.workorder-left {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.workorder-stat {
  padding: 12px;
  background: rgba(0, 212, 255, 0.05);
  border: 1px solid rgba(0, 212, 255, 0.2);
  border-radius: 8px;
  text-align: center;
  .stat-label {
    font-size: 12px;
    color: #a0b3c8;
    margin-bottom: 8px;
  }
  .stat-value {
    font-size: 24px;
    font-weight: bold;
    color: #00d4ff;
    margin-bottom: 8px;
    .stat-unit {
      font-size: 14px;
      font-weight: normal;
    }
  }
  .stat-badge {
    display: inline-block;
    padding: 4px 10px;
    background: rgba(0, 212, 255, 0.2);
    border-radius: 12px;
    font-size: 11px;
    color: #00d4ff;
  }
}

.workorder-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-height: 0;
}

.status-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.status-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 10px;
  background: rgba(0, 212, 255, 0.05);
  border: 1px solid rgba(0, 212, 255, 0.2);
  border-radius: 6px;
  .status-label {
    font-size: 12px;
    color: #a0b3c8;
  }
  .status-value {
    font-size: 14px;
    font-weight: bold;
    &.cyan {
      color: #00d4ff;
    }
    &.red {
      color: #ff6b6b;
    }
  }
}

.satisfaction {
  .satisfaction-label {
    font-size: 12px;
    color: #a0b3c8;
    margin-bottom: 12px;
  }
  .satisfaction-bars {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .bar-item {
    display: flex;
    align-items: center;
    gap: 10px;
    .bar-label {
      font-size: 12px;
      color: #a0b3c8;
      min-width: 60px;
    }
    .bar-wrapper {
      flex: 1;
      height: 20px;
      background: rgba(0, 212, 255, 0.1);
      border-radius: 10px;
      overflow: hidden;
    }
    .bar-fill {
      height: 100%;
      border-radius: 10px;
    }
    .bar-value {
      font-size: 12px;
      color: #00d4ff;
      min-width: 40px;
      text-align: right;
    }
  }
}

// ========== 中央地图（底部背景层）==========
.alarm-center-panel {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 1; // 地图在底部
  overflow: hidden;
}

.amap-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  
  // 高德地图样式覆盖
  ::v-deep .amap-icon {
    img {
      position: static !important;
      width: 100% !important;
      height: 100% !important;
      display: block !important;
    }
  }
  
  // 自定义地图控件样式，匹配大屏科技主题
  ::v-deep .amap-controls {
    .amap-toolbar,
    .amap-scale,
    .amap-logo,
    .amap-copyright {
      background: rgba(15, 30, 50, 0.9) !important;
      border: 1px solid rgba(0, 212, 255, 0.3) !important;
      color: #00d4ff !important;
      backdrop-filter: blur(10px);
    }
  }
  
  ::v-deep .amap-marker-label {
    background: rgba(15, 30, 50, 0.9) !important;
    border: 1px solid rgba(0, 212, 255, 0.3) !important;
    color: #00d4ff !important;
    backdrop-filter: blur(10px);
  }
  
  // 宠物标记样式
  ::v-deep .pet-marker-wrapper {
    position: relative;
    display: inline-block;
    text-align: center;
    
    .pet-marker-label {
      position: absolute;
      bottom: 32px;
      left: 50%;
      transform: translateX(-50%);
      background: rgba(0, 0, 0, 0.7);
      padding: 3px 8px;
      border-radius: 4px;
      font-size: 11px;
      font-weight: bold;
      white-space: nowrap;
      border: 1px solid;
      backdrop-filter: blur(5px);
      pointer-events: none;
      z-index: 3;
      text-shadow: 0 1px 2px rgba(0, 0, 0, 0.8);
    }
    
    .marker-pulse {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 28px;
      height: 28px;
      border-radius: 50%;
      opacity: 0;
      z-index: 1;
      animation: pulse 2s ease-out infinite;
    }
    
    .pet-marker-icon {
      position: relative;
      z-index: 2;
      display: block;
    }
    
    // 不同宠物的呼吸灯颜色
    &.marker-pet-pet-001 .marker-pulse {
      background: #FF6B9D;
      color: #FF6B9D;
    }
    &.marker-pet-pet-002 .marker-pulse {
      background: #4ECDC4;
      color: #4ECDC4;
    }
    &.marker-pet-pet-003 .marker-pulse {
      background: #FFE66D;
      color: #FFE66D;
    }
  }
  
  @keyframes pulse {
    0% {
      transform: translate(-50%, -50%) scale(1);
      opacity: 0.8;
    }
    50% {
      transform: translate(-50%, -50%) scale(1.5);
      opacity: 0.4;
    }
    100% {
      transform: translate(-50%, -50%) scale(2);
      opacity: 0;
    }
  }
  
  // 轨迹点动画
  @keyframes trackPointPulse {
    0%, 100% {
      transform: scale(1);
      opacity: 0.8;
    }
    50% {
      transform: scale(1.3);
      opacity: 1;
    }
  }
  
  // 新的宠物标记动画
  @keyframes petPulse {
    0% {
      transform: translate(-50%, -50%) scale(1);
      opacity: 0.6;
    }
    50% {
      transform: translate(-50%, -50%) scale(1.3);
      opacity: 0.3;
    }
    100% {
      transform: translate(-50%, -50%) scale(1.8);
      opacity: 0;
    }
  }
  
  @keyframes petMarkerFloat {
    0%, 100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-8px);
    }
  }
  
  @keyframes petTrackPulse {
    0%, 100% {
      transform: scale(1);
      opacity: 0.8;
    }
    50% {
      transform: scale(1.4);
      opacity: 1;
    }
  }
  
  // 轨迹点样式
  ::v-deep .pet-track-point {
    animation: trackPointPulse 2s ease-in-out infinite;
  }
  
  ::v-deep .pet-start-point {
    animation: trackPointPulse 2s ease-in-out infinite;
  }
}

// 地图正下方悬浮的健康活动列表包装器（居中于右侧面板左侧，带间距，响应式）
.map-alarm-list-wrapper {
  position: absolute;
  bottom: 20px;
  left: 20px; // 左侧没有面板，直接使用左边距
  right: calc(min(430px, 22vw) + 20px); // 右侧面板宽度 + 间距，响应式
  z-index: 200; // 确保在地图和左右面板之上
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  pointer-events: auto; // 确保可以交互
  min-width: 400px; // 确保最小宽度
  
  // 响应式调整
  @media (max-width: 1920px) {
    right: calc(min(410px, 22vw) + 20px);
  }
  
  @media (max-width: 1600px) {
    right: calc(min(380px, 24vw) + 20px);
    min-width: 300px;
  }
  
  @media (max-width: 1366px) {
    right: calc(min(350px, 26vw) + 20px);
    min-width: 250px;
  }
}

// 展开按钮（当列表隐藏时显示）
.alarm-list-toggle-btn {
  background: rgba(15, 30, 50, 0.85);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 212, 255, 0.5);
  border-radius: 4px;
  padding: 8px 16px;
  color: #00d4ff;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;

  .toggle-text {
    font-weight: 500;
    margin-right: 10px;
  }

  .toggle-icon-up {
    display: inline-block;
    line-height: 1;
    letter-spacing: -2px;
  }

  &:hover {
    background: rgba(15, 30, 50, 0.95);
    border-color: #00d4ff;
    box-shadow: 0 4px 15px rgba(0, 212, 255, 0.4);
  }
}

// 地图正下方悬浮的摄像头监控列表
.map-alarm-list {
  background: rgba(15, 30, 50, 0.92);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
  width: 100%;
  max-width: 100%; // 使用父容器的全部宽度
  max-height: calc(100vh - 200px); // 确保不会被遮挡
  display: flex;
  flex-direction: column;
  overflow: hidden;
  pointer-events: auto; // 确保可以交互

  .alarm-list-header {
    padding: 12px 16px;
    border-bottom: 1px solid rgba(0, 212, 255, 0.2);
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    user-select: none;
    gap: 12px;

    .section-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex: 1;
      margin-bottom: 0;
    }

    .section-title {
      margin-bottom: 0;
      font-size: 14px;
    }

    .toggle-btn {
      background: transparent;
      border: none;
      color: #00d4ff;
      font-size: 14px;
      cursor: pointer;
      padding: 4px 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: opacity 0.3s ease;

      .toggle-icon-down {
        display: inline-block;
      }

      &:hover {
        opacity: 0.8;
      }
    }
  }

  .alarm-list-scroll {
    overflow-y: auto;
    flex: 1;
    padding: 16px;
    min-height: 0;

    // 隐藏滚动条但保留滚动功能
    scrollbar-width: none; // Firefox
    -ms-overflow-style: none; // IE/Edge

    &::-webkit-scrollbar {
      display: none; // Chrome/Safari
    }
  }
}

.camera-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}

.camera-item {
  position: relative;
  aspect-ratio: 16 / 9;
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
  background: rgba(15, 30, 50, 0.8);
  border: 1px solid rgba(0, 212, 255, 0.2);

  &:hover {
    border-color: rgba(0, 212, 255, 0.5);
    box-shadow: 0 4px 12px rgba(0, 212, 255, 0.3);
    transform: translateY(-2px);
  }
}

.camera-image-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.camera-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.camera-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(0, 212, 255, 0.05);

  .placeholder-icon {
    font-size: 48px;
    margin-bottom: 8px;
    opacity: 0.6;
  }

  .placeholder-text {
    font-size: 12px;
    color: #a0b3c8;
    text-align: center;
  }
}

.camera-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0) 100%);
  padding: 8px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .camera-name {
    font-size: 12px;
    color: #fff;
    font-weight: 500;
  }

}

.alarm-table {
  .table-header {
    display: grid;
    grid-template-columns: 0.8fr 1.2fr 0.9fr 1.1fr 1.2fr 0.8fr 0.7fr;
    gap: 6px;
    padding: 10px 8px;
    background: rgba(0, 212, 255, 0.1);
    border-radius: 6px;
    margin-bottom: 8px;
    .th {
      font-size: 12px;
      font-weight: bold;
      color: #00d4ff;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .table-row {
    display: grid;
    grid-template-columns: 0.8fr 1.2fr 0.9fr 1.1fr 1.2fr 0.8fr 0.7fr;
    gap: 6px;
    padding: 10px 8px;
    border-radius: 4px;
    margin-bottom: 6px;
    font-size: 12px;
    color: #a0b3c8;
    background: rgba(0, 212, 255, 0.02);
    transition: all 0.3s ease;

    &:hover {
      background: rgba(0, 212, 255, 0.08);
    }

    .td {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: flex;
      align-items: center;
    }
  }
}

.detail-btn {
  padding: 4px 12px;
  background: #00d4ff;
  border: none;
  border-radius: 4px;
  color: #000;
  font-size: 11px;
  font-weight: bold;
  cursor: pointer;
  white-space: nowrap;
  &:hover {
    background: #00b8e6;
  }
}

// 过渡动画
.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.3s ease;
}

.slide-up-enter {
  transform: translateY(100%);
  opacity: 0;
}

.slide-up-leave-to {
  transform: translateY(100%);
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

// ========== 右侧面板 ==========
// ========== 右侧面板（覆盖在地图上，响应式）==========
.alarm-right-panel-wrapper {
  position: absolute;
  top: 20px;
  right: 20px;
  width: min(430px, 22vw); // 自适应：最大430px，或屏幕宽度的22%
  min-width: 320px; // 最小宽度
  max-width: 430px; // 最大宽度
  height: calc(100% - 40px);
  z-index: 10; // 右侧面板在地图上方
  border-radius: 8px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: rgba(15, 30, 50, 0.85);
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
  
  // 响应式调整
  @media (max-width: 1920px) {
    width: min(410px, 22vw);
    max-width: 410px;
  }
  
  @media (max-width: 1600px) {
    width: min(380px, 24vw);
    max-width: 380px;
    min-width: 300px;
  }
  
  @media (max-width: 1366px) {
    width: min(350px, 26vw);
    max-width: 350px;
    min-width: 280px;
  }
}

.alarm-right-panel {
  display: flex;
  flex-direction: column;
  gap: 8px; // 与左侧保持一致
  flex: 1; // 占据剩余空间
  min-height: 0; // 重要：允许 flex 子元素缩小
  overflow-y: auto; // 内容超出时显示滚动条
  overflow-x: hidden;
  max-height: 100%; // 限制最大高度，确保可以滚动

  // 隐藏滚动条但保留滚动功能
  scrollbar-width: none; // Firefox
  -ms-overflow-style: none; // IE/Edge

  &::-webkit-scrollbar {
    display: none; // Chrome/Safari
  }

  ::v-deep .card {
    padding: 10px; // 与社区态势保持一致
  }

  ::v-deep .section-title {
    margin-bottom: 0; // 与社区态势保持一致
    font-size: 14px; // 与社区态势保持一致
  }

  // 所有卡片默认根据内容自适应
  .card {
    flex: 0 0 auto;
    min-height: 0; // 允许收缩
  }

  // 最后一个卡片占据剩余空间，并设置为 flex 容器
  .card:last-child {
    flex: 1 0 auto; // 占据剩余空间，但不收缩，允许根据内容增长
    display: flex;
    flex-direction: column;
    // 不设置 min-height，让内容自然增长
    // 不设置 overflow，让内容自然溢出，由父容器 .alarm-right-panel 处理滚动
  }
}

.alarm-right-panel .section-header {
  margin-bottom: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.alarm-right-panel .section-title {
  font-size: 14px;
  margin-bottom: 0;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.section-title {
  font-size: 14px;
  margin-bottom: 0;

  .title-icon {
    font-size: 18px;
    margin-right: 8px;
  }
}

.section-alarm-list {
  flex: 1 1 0; // 占据剩余空间，但允许收缩，基础大小为0
  min-height: 0; // 允许收缩
  display: flex;
  flex-direction: column;
  overflow: hidden; // 防止内容溢出
}

.alarm-list-scroll {
  flex: 1;
  min-height: 0;
  padding-right: 2px;
  overflow-y: auto; // 内容超出时显示滚动条

  // 隐藏滚动条但保留滚动功能
  scrollbar-width: none; // Firefox
  -ms-overflow-style: none; // IE/Edge

  &::-webkit-scrollbar {
    display: none; // Chrome/Safari
  }
}

.alarm-table {
  .table-header {
    display: grid;
    grid-template-columns: 0.8fr 1.2fr 0.9fr 1.1fr 1.2fr 0.8fr 0.7fr;
    gap: 6px;
    padding: 10px 8px;
    background: rgba(0, 212, 255, 0.1);
    border-radius: 6px;
    margin-bottom: 8px;
    .th {
      font-size: 12px;
      font-weight: bold;
      color: #00d4ff;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .table-row {
    display: grid;
    grid-template-columns: 0.8fr 1.2fr 0.9fr 1.1fr 1.2fr 0.8fr 0.7fr;
    gap: 6px;
    padding: 10px 8px;
    border-radius: 4px;
    margin-bottom: 6px;
    font-size: 12px;
    color: #a0b3c8;
    background: rgba(0, 212, 255, 0.02);
    transition: all 0.3s ease;

    &:hover {
      background: rgba(0, 212, 255, 0.08);
    }

    &.new-alarm {
      background: rgba(255, 152, 0, 0.15);
      border-left: 3px solid rgba(255, 152, 0, 0.8);
      animation: slideInFromTop 0.5s ease-out;

      &:hover {
        background: rgba(255, 152, 0, 0.2);
      }
    }

    .td {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: flex;
      align-items: center;
    }
  }
}

.status-badge {
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  &.unassigned {
    background: rgba(255, 107, 107, 0.2);
    color: #ff6b6b;
  }
  &.assigned {
    background: rgba(0, 212, 255, 0.2);
    color: #00d4ff;
  }
  &.cancelled {
    background: rgba(255, 193, 7, 0.2);
    color: #ffc107;
  }
}

.detail-btn {
  padding: 4px 12px;
  background: #00d4ff;
  border: none;
  border-radius: 4px;
  color: #000;
  font-size: 11px;
  font-weight: bold;
  cursor: pointer;
  white-space: nowrap;
  &:hover {
    background: #00b8e6;
  }
}

// 过渡动画 - Vue 2 使用 enter/leave，Vue 3 使用 enter-from/leave-to
.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.3s ease;
}

.slide-up-enter {
  transform: translateY(100%);
  opacity: 0;
}

.slide-up-leave-to {
  transform: translateY(100%);
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

// 新消息动画
@keyframes slideInFromTop {
  0% {
    opacity: 0;
    transform: translateY(-20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

// 视频播放器弹窗样式
.video-mask {
  position: fixed;
  inset: 0;
  z-index: 300;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
}

.video-modal {
  width: min(980px, calc(100% - 40px));
  height: min(620px, calc(100% - 40px));
  background: rgba(15, 30, 50, 0.92);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 8px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.45);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.video-header {
  height: 44px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(0, 212, 255, 0.2);
}

.video-title {
  color: #fff;
  font-size: 14px;
  font-weight: 700;
}

.video-actions {
  display: flex;
  gap: 6px;
}

.icon-btn {
  width: 32px;
  height: 28px;
  border-radius: 6px;
  border: 1px solid rgba(0, 212, 255, 0.2);
  background: rgba(0, 212, 255, 0.06);
  color: rgba(255, 255, 255, 0.92);
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(0, 212, 255, 0.15);
    border-color: rgba(0, 212, 255, 0.4);
    color: #fff;
  }
}

.video-body {
  flex: 1;
  position: relative;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
}

.jessibuca-container-modal {
  width: 100%;
  height: 100%;
}

.video-empty {
  color: #a0b3c8;
  font-size: 14px;
}

// 社区水质监测详情弹窗样式
.environment-detail-mask {
  position: fixed;
  inset: 0;
  z-index: 300;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
}

.environment-detail-modal {
  width: min(90%, calc(100% - 40px));
  height: min(95vh, calc(100% - 20px));
  background: rgba(15, 30, 50, 0.92);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 8px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.45);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.environment-detail-header {
  height: 44px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(0, 212, 255, 0.2);
  background: rgba(0, 212, 255, 0.05);
}

.environment-detail-title {
  color: #00d4ff;
  font-size: 14px;
  font-weight: 700;
}

.environment-detail-actions {
  display: flex;
  gap: 6px;
}

.environment-detail-body {
  flex: 1;
  position: relative;
  background: rgba(15, 30, 50, 0.95);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
</style>
